import { Component, computed, inject } from '@angular/core';
import {
    FieldFieldComponent,
    FieldMappingComponent,
    FieldRowComponent,
    InstructionsComponent,
    RowOptionChoice,
} from '@r1-compass-library/components';
import { ReactiveFormsModule, NonNullableFormBuilder } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { SalesforceFieldMetadata } from '@r1-compass-library/models';
import { DivisionSalesforceTargetsFormValidatorsService } from '../division-salesforce-targets-form-validators.service';
import { DivisionSalesforceTargetsFormService } from '../division-salesforce-targets-form.service';
import { DivisionSalesforceTargetsForm } from '../form.model';

@Component({
    selector: 'r1-compass-app-salesforce-target-objects',
    imports: [
        FieldFieldComponent,
        FieldMappingComponent,
        FieldRowComponent,
        InstructionsComponent,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        ReactiveFormsModule,
    ],
    templateUrl: './salesforce-target-objects.component.html',
})
export class SalesforceTargetObjectsComponent {
    protected readonly formService = inject(DivisionSalesforceTargetsFormService);
    readonly #fb = inject(NonNullableFormBuilder);
    readonly #validators = inject(DivisionSalesforceTargetsFormValidatorsService);

    protected formState = this.formService.salesforceTargetsFormState;

    protected formArray: DivisionSalesforceTargetsForm['uniqueSalesforceTargetFields'] =
        this.formService.divisionSalesforceTargetsForm.controls.uniqueSalesforceTargetFields;

    protected claimsMapped = computed(() => {
        const claimed = this.salesforceRecommendationFields();

        function mapClaimData(fields: SalesforceFieldMetadata[]) {
            return fields.map((field, index) => ({
                field: field,
                claimed: claimed.includes(field),
                index: index,
            }));
        }

        return mapClaimData(this.salesforceRecommendationFields());
    });

    private salesforceRecommendationFields = computed<SalesforceFieldMetadata[]>(
        () =>
            this.formState.recommendationFieldsOptions()?.fields.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            }) ?? []
    );

    protected addMapperRow() {
        this.formService.addUnrequiredRow(
            this.formService.divisionSalesforceTargetsForm.controls.uniqueSalesforceTargetFields,
            this.#fb,
            this.#validators
        );
        this.formService.divisionSalesforceTargetsForm.controls.uniqueSalesforceTargetFields.markAllAsDirty();
        this.formService.divisionSalesforceTargetsForm.markAllAsDirty();
    }

    protected deleteMapperRow(option: RowOptionChoice) {
        this.formService.divisionSalesforceTargetsForm.controls.uniqueSalesforceTargetFields.removeAt(option.index);
        this.formService.divisionSalesforceTargetsForm.markAllAsDirty();
    }
}
